<template>
    <a-drawer :title="title" width="500" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="模板信息" bordered :column="1" size="middle">
            <a-descriptions-item label="模板名称">
                {{ detail.name }}
            </a-descriptions-item>
            <a-descriptions-item label="证书类型">
                <a-tag color="#f50">
                    {{ detail.type | fmtCertType }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="证书级别">
                <a-tag color="#108ee9">
                    {{ detail.grade | fmtCertGrade }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="证书等级">
                <a-tag color="#2db7f5">
                    {{ detail.level }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="发证单位">
                {{ detail.munit }}
            </a-descriptions-item>
            <a-descriptions-item label="有效期">
                {{ detail.days | fmtDays }}
            </a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <div class="ant-descriptions-title">证书样图</div>
        <a-row :gutter="[10, 10]">
            <a-col :span="6" v-for="img in images" :key="img">
                <div :style="{ width: '100px', height: '100px', border: '1px dashed grey', padding: '3px' }">
                    <img :src="img" :style="{ width: '100%', height: '100%' }" />
                </div>
            </a-col>
        </a-row>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        images() {
            return this.detail.imgs.split(',')
        }
    },
    data() {
        return {
            detail: {
                imgs: ''
            }
        }
    },
    mounted() {
        this.$http
            .get('/crs/cert/tmpl/detail', {
                params: {
                    id: this.item.id
                }
            })
            .then(result => {
                this.detail = result.data
            })
    }
}
</script>
